import { Box } from '../../../box';
import styles from '../../Summary.module.css';
import { Icon, IconName, Text } from '../../../..';
import clsx from 'clsx';
import { ReactNode } from 'react';

export type SummarySubItemProps = {
	icon?: IconName;
	text?: string;
	price?: string;
	number?: number;
	children?: ReactNode;
};

export const SummarySubItem = (props: SummarySubItemProps) => {
	const { icon, number, text, price, children } = props;
	return (
		<Box
			className={clsx((icon || number || text) && children ? styles.summary_subitem_content : styles.summary_subtitle)}
		>
			<Box className={styles.summary_price}>
				<Box className={styles.summary_subitem_title}>
					{icon && <Icon className={styles.summary_subitem_icon} name={icon}></Icon>}
					{(text || number) && (
						<Text className={icon && styles.summary_subitem_title} as="span" font="verdana" size="lg-bold">
							{number ? `${String(number)} ${String(text)}` : text}
						</Text>
					)}
				</Box>
				{price && (
					<Text className={styles.summary_price_black} font="verdana" size="lg-regular">
						{price}
					</Text>
				)}
			</Box>
			<Box className={icon ? styles.summary_item_icon_children : styles.summary_item_children}>{children}</Box>
		</Box>
	);
};
SummarySubItem.displayName = 'SummarySubItem';
